<template>
  <div>
    <nav class="bar bar-nav">
      <a class="icon icon-left pull-left" @click="goBack"></a>
      <h1 class="title">新增发票抬头</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">单位名称</div>
                <div class="item-input">
                  <input class="open-popup open-enterprise" data-popup=".popup-enterprise" type="text"
                         placeholder="单位名称" id="enterpriseName" v-model.trim="addEnterprise" readonly unselectable="on">
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">设为默认</div>
                <div class="item-input" style="margin-top: 1px;margin-left: 45%;">
                  <label class="label-switch">
                    <input type="checkbox"  v-model="isDefaultString">
                    <div class="checkbox"></div>
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-50"><a @click="goBack" class="button button-big button-fill button-danger">取消</a></div>
          <div class="col-50"><a @click="submit" class="button button-big button-fill button-success">确认</a></div>
       </div>
      </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'

  export default {
    created () {
    },
    mounted () {
      let _this = this
      $(document).on('close', function () {
        _this.addEnterprise = _this.enterpriseInfo.enterpriseName
      })
    },
    data () {
      return {
        addEnterprise: '',
        isDefaultString: true,
        href: 'javascript:;'
      }
    },
    computed: {
      ...mapState([
        'sessionInfo', 'enterpriseInfo'
      ])
    },
    methods: {
      ...mapMutations([
        'INVOICE_TITLE'
      ]),
      checkInfo () {
        var _this = this
        if (_this.addEnterprise === '') {
          _this.error = '请填写单位名称'
          return false
        }
//        if (_this.isDefaultString === '') {
//          _this.error = '请选择是否设置为默认'
//          return false
//        }
        return true
      },
      submit () {
        var _this = this
        if (_this.checkInfo()) {
          _this.href = 'javascript:window.history.back()'
          _this.gcapi('gcwwwifc/createOrUpdateInvoiceTitle', {
            'IsDefault': _this.isDefaultString === true ? 1 : 0,
            'EnterpriseNo': _this.enterpriseInfo.enterpriseNo
          }).then((response) => {
            if (response.body.code === 0) {
              $.toast('添加成功')
              _this.goBack()
            } else {
              $.toast('出错')
            }
          })
        } else {
          $.toast(_this.error)
        }
      },
      goBack () {
        this.$router.push({name: 'invoiceTitle', query: {from: this.$route.query.from}, params: {order: this.$route.params.order}})
      }
    }
  }

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// AddInvoiceTitle.vue?7b4183ec